import {
  useGetUser
} from "./chunk-FK3OZNK2.mjs";
import {
  getWalletHistory
} from "./chunk-KYWS2TJG.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/wallet/history.ts
import { useQuery } from "@tanstack/react-query";
var useGetWalletHistory = (props) => {
  const { data: user } = useGetUser(props, { enabled: false });
  return useQuery({
    queryKey: ["getWalletHistory", __spreadProps(__spreadValues({}, props), { userId: user == null ? void 0 : user._id })],
    queryFn: () => getWalletHistory(props),
    enabled: !!user,
    staleTime: Infinity,
    gcTime: Infinity
  });
};

export {
  useGetWalletHistory
};
//# sourceMappingURL=chunk-MKTBAA64.mjs.map